import React, { useState, useEffect } from "react";
import axios from "axios";

const baseUrl =
  process.env.REACT_APP_PUBLIC_API_URL
  
   
const AgricultureInterestCard = () => {
  const [interests, setInterests] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseUrl}/value-chain-distribution`)
      .then((response) => {
        const res = response.data;
        if (res.success && Array.isArray(res.distribution)) {
          setInterests(
            res.distribution.map((item) => ({
              label: item.label,
              value: item.value,
            }))
          );
        }
      })
      .catch((error) =>
        console.error("Error fetching value chain distribution:", error)
      );
  }, []);

  return (
    <div className="bg-white p-8 rounded-2xl shadow-sm w-full border border-gray-100">
      <h2 className="text-xl font-bold text-gray-900 mb-8">
        Agriculture Interest
      </h2>

      {interests.length > 0 ? (
        <div className="space-y-4">
          {interests.map((item, index) => (
            <div key={index} className="flex items-center group">
              <span className="text-gray-600 text-sm font-medium pr-4 whitespace-nowrap">
                {item.label}
              </span>
              <div className="flex-grow border-b border-gray-200 mb-1 opacity-60"></div>
              <span className="text-gray-500 text-sm font-semibold pl-4 tabular-nums">
                {typeof item.value === "number"
                  ? item.value.toLocaleString()
                  : item.value}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-gray-500">No data yet.</p>
      )}
    </div>
  );
};

export default AgricultureInterestCard;
